import {
  Component,
  Inject,
  Input,
  Output,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Renderer2,
  ElementRef,
  TemplateRef,
  SimpleChange,
  ContentChild,
  Optional
} from "@angular/core";
import { DecimalPipe, DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
// import { ACLService } from '@fui/auth';
import { Observable, Subscription, of } from "rxjs";
import { tap, map, filter } from "rxjs/operators";
import {
  CNCurrencyPipe,
  DatePipe,
  YNPipe,
  ModalHelper,
  ModalHelperOptions
} from "fui-theme";
import { deepGet, deepCopy, toBoolean, toNumber } from "../util";

import {
  SimpleTableColumn,
  SimpleTableChange,
  CompareFn,
  SimpleTableSelection,
  SimpleTableFilter,
  SimpleTableData,
  SimpleTableButton,
  STExportOptions,
  ResReNameType,
  ReqReNameType,
  SimpleTableMultiSort
} from "./interface";
import { AdSimpleTableConfig } from "./simple-table.config";
import { SimpleTableExport } from "./simple-table-export";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "simple-table",
  templateUrl: "./simple-table.component.html",
  // tslint:disable-next-line:use-host-property-decorator
  host: { "[class.ad-st]": "true" },
  providers: [SimpleTableExport, CNCurrencyPipe, DatePipe, YNPipe, DecimalPipe],
  preserveWhitespaces: false
})
export class SimpleTableComponent implements OnInit, OnChanges, OnDestroy {
  private data$: Subscription;
  private _inited = false;
  _data: SimpleTableData[] = [];
  _url: string;
  _isAjax = false;
  _isPagination = true;
  _classMap: string[] = [];
  _allChecked = false;
  _indeterminate = false;
  _columns: SimpleTableColumn[] = [];
  _sortMap: { [key: number]: any } = {};
  _sortColumn: SimpleTableColumn = null;
  _sortOrder: string;
  _sortIndex: number;

  // region: fields

  /** æ°æ®æº */
  @Input()
  data: string | any[] | Observable<any[]>;
  /**
   * é¢å¤è¯·æ±åæ°ï¼é»è®¤èªå¨éå  `pi`ã`ps` è³URL
   * - `{ status: 'new' }` => `url?pi=1&ps=10&status=new`
   */
  @Input()
  extraParams: any;
  /** è¯·æ±æ¹æ³ */
  @Input()
  reqMethod = "GET";
  /** è¯·æ±ä½ `body` */
  @Input()
  reqBody: any;
  /** è¯·æ±ä½ `Header` */
  @Input()
  reqHeaders: any;
  /**
   * éå½åè¯·æ±åæ° `pi`ã`ps`
   * - `{ pi: 'Page' }` => `pi` ä¼è¢«æ¿æ¢æ Page
   */
  @Input()
  set reqReName(value: ReqReNameType) {
    this._reqReName = Object.assign(this._reqReName, value);
  }
  get reqReName() {
    return this._reqReName;
  }
  private _reqReName: ReqReNameType = { pi: "pi", ps: "ps" };
  /** è¯·æ±å¼å¸¸æ¶åè° */
  @Output()
  readonly reqError: EventEmitter<any> = new EventEmitter<any>();
  /**
   * éå½åè¿ååæ° `total`ã`list`
   * - `{ total: 'Total' }` => Total ä¼è¢«å½ä½ `total`
   */
  @Input()
  set resReName(cur: ResReNameType) {
    let ret: ResReNameType = {};
    if (cur) {
      if (cur.list) {
        ret.list = Array.isArray(cur.list) ? cur.list : cur.list.split(".");
      } else {
        ret.list = ["list"];
      }

      if (cur.total) {
        ret.total = Array.isArray(cur.total) ? cur.total : cur.total.split(".");
      } else {
        ret.total = ["total"];
      }
    } else {
      ret = { total: ["total"], list: ["list"] };
    }
    this._resReName = ret;
  }
  get resReName() {
    return this._resReName;
  }
  private _resReName: ResReNameType = { total: ["total"], list: ["list"] };
  /** åæè¿°  */
  @Input()
  columns: SimpleTableColumn[] = [];
  /** æ¯é¡µæ°éï¼å½è®¾ç½®ä¸º `0` è¡¨ç¤ºä¸åé¡µï¼é»è®¤ï¼`10` */
  @Input()
  get ps() {
    return this._ps;
  }
  set ps(value: any) {
    this._ps = toNumber(value);
  }
  private _ps = 10;
  /** å½åé¡µç  */
  @Input()
  get pi() {
    return this._pi;
  }
  set pi(value: any) {
    this._pi = toNumber(value);
  }
  private _pi = 1;
  /** æ°æ®æ»é */
  @Input()
  get total() {
    return this._total;
  }
  set total(value: any) {
    this._total = toNumber(value);
  }
  private _total = 0;
  /** æ¯å¦æ¾ç¤ºåé¡µå¨ */
  @Input()
  get showPagination() {
    return this._showPagination;
  }
  set showPagination(value: any) {
    this._showPagination = toBoolean(value, true);
  }
  private _showPagination: boolean;
  /** æ¯å¦æ¾ç¤ºLoading */
  @Input()
  get loading() {
    return this._loading;
  }
  set loading(value: any) {
    this._loading = toBoolean(value);
  }
  private _loading = false;
  /** å»¶è¿æ¾ç¤ºå è½½ææçæ¶é´ï¼é²æ­¢éªçï¼ */
  @Input()
  get loadingDelay() {
    return this._loadingDelay;
  }
  set loadingDelay(value: any) {
    this._loadingDelay = toNumber(value);
  }
  private _loadingDelay = 0;
  /** æ¯å¦æ¾ç¤ºè¾¹æ¡ */
  @Input()
  get bordered() {
    return this._bordered;
  }
  set bordered(value: any) {
    this._bordered = toBoolean(value);
  }
  private _bordered = false;
  /** tableå¤§å° */
  @Input()
  size: "small" | "middle" | "default" = "default";
  /** çºµåæ¯ææ»å¨ï¼ä¹å¯ç¨äºæå®æ»å¨åºåçé«åº¦ï¼`{ y: '300px', x: '300px' }` */
  @Input()
  scroll: { y?: string; x?: string };
  /** æ¯å¦æ¾ç¤ºpaginationä¸­æ¹åé¡µæ° */
  @Input()
  get showSizeChanger() {
    return this._showSizeChanger;
  }
  set showSizeChanger(value: any) {
    this._showSizeChanger = toBoolean(value);
  }
  private _showSizeChanger = false;
  /** paginationä¸­æ¯é¡µæ¾ç¤ºæ¡ç®æ°ä¸ææ¡å¼ */
  @Input()
  pageSizeOptions: number[];
  /** æ¯å¦æ¾ç¤ºpaginationä¸­å¿«éè·³è½¬ */
  @Input()
  get showQuickJumper() {
    return this._showQuickJumper;
  }
  set showQuickJumper(value: any) {
    this._showQuickJumper = toBoolean(value);
  }
  private _showQuickJumper = false;
  /** æ¯å¦æ¾ç¤ºæ»æ°æ®é */
  private _totalTpl = ``;
  @Input()
  set showTotal(value: any) {
    if (typeof value === "string" && value.length) {
      this._totalTpl = value;
    } else if (toBoolean(value)) {
      this._totalTpl = `å± {{total}} æ¡`;
    } else {
      this._totalTpl = "";
    }
  }
  renderTotal(total: string, range: string[]) {
    return this._totalTpl
      ? this._totalTpl
          .replace("{{total}}", total)
          .replace("{{range[0]}}", range[0])
          .replace("{{range[1]}}", range[1])
      : "";
  }
  /**
   * åç«¯åé¡µï¼å½ `data` ä¸º`any[]` æ `Observable<any[]>` ææï¼é»è®¤ï¼`true`
   * - `true` ç± `simple-table` æ ¹æ® `data` é¿åº¦åæ§åé¡µï¼åæ¬ï¼æåºãè¿æ»¤ç­
   * - `false` ç±ç¨æ·éè¿ `total` å `data` åæ°åæ§åé¡µï¼å¹¶ç»´æ¤ `(change)` å½åé¡µåæ´æ¶éæ°å è½½æ°æ®
   */
  @Input()
  get frontPagination() {
    return this._frontPagination;
  }
  set frontPagination(value: any) {
    this._frontPagination = toBoolean(value);
  }
  // tslint:disable-next-line:member-ordering
  private _frontPagination: boolean;
  /** æ°æ®åæ´åæ¯å¦ä¿çå¨æ°æ®åæ´åçé¡µç  */
  @Input()
  get isPageIndexReset() {
    return this._isPageIndexReset;
  }
  set isPageIndexReset(value: any) {
    this._isPageIndexReset = toBoolean(value);
  }
  // tslint:disable-next-line:member-ordering
  private _isPageIndexReset = true;
  /** åé¡µæ¹å */
  // tslint:disable-next-line:member-ordering
  @Input()
  pagePlacement?: "left" | "center" | "right" = "right";
  /** åæ¢åé¡µæ¶è¿åé¡¶é¨ */
  @Input()
  get toTopInChange() {
    return this._toTopInChange;
  }
  set toTopInChange(value: any) {
    this._toTopInChange = toBoolean(value);
  }
  // tslint:disable-next-line:member-ordering
  private _toTopInChange = true;
  /** è¿åé¡¶é¨åç§»å¼ */
  @Input()
  get toTopOffset() {
    return this._toTopOffset;
  }
  set toTopOffset(value: any) {
    this._toTopOffset = toNumber(value);
  }
  // tslint:disable-next-line:member-ordering
  private _toTopOffset = 100;
  /** éå½åæåºå¼ï¼`columns` çéå½åé«äºå±æ§ */
  // tslint:disable-next-line:member-ordering
  @Input()
  sortReName: { ascend?: string; descend?: string };
  /** æ¯å¦å¤æåºï¼å½ `sort` å¤ä¸ªç¸åå¼æ¶èªå¨åå¹¶ï¼å»ºè®®åç«¯æ¯ææ¶ä½¿ç¨ */
  @Input()
  get multiSort() {
    return this._multiSort;
  }
  set multiSort(value: any) {
    if (typeof value === "object") {
      this._multiSort = Object.assign(
        <SimpleTableMultiSort>{
          key: "sort",
          separator: "-",
          name_separator: "."
        },
        value
      );
    } else {
      this._multiSort = toBoolean(value);
    }
  }
  // tslint:disable-next-line:member-ordering
  private _multiSort: boolean | SimpleTableMultiSort;
  /** æ°æ®å¤çååè° */
  // tslint:disable-next-line:member-ordering
  @Input()
  preDataChange: (data: SimpleTableData[]) => SimpleTableData[];
  /** `header` æ é¢ */
  // tslint:disable-next-line:member-ordering
  @ContentChild("header")
  header: TemplateRef<void>;
  /** é¢å¤ `body` åå®¹ */
  // tslint:disable-next-line:member-ordering
  @ContentChild("body")
  body: TemplateRef<void>;
  /** `footer` åºé¨ */
  // tslint:disable-next-line:member-ordering
  @ContentChild("footer")
  footer: TemplateRef<void>;
  /** `expand` å¯å±å¼ï¼å½æ°æ®æºä¸­åæ¬ `expand` è¡¨ç¤ºå±å¼ç¶æ */
  // tslint:disable-next-line:member-ordering
  @ContentChild("expand")
  expand: TemplateRef<{ $implicit: any; column: SimpleTableColumn }>;
  // tslint:disable-next-line:member-ordering
  @Input()
  noResult: string | TemplateRef<void>;
  // tslint:disable-next-line:member-ordering
  @Input()
  widthConfig: string[];
  /** é¡µç ãæ¯é¡µæ°éååæ¶åè° */
  // tslint:disable-next-line:member-ordering
  @Output()
  readonly change: EventEmitter<SimpleTableChange> = new EventEmitter<
    SimpleTableChange
  >();
  /** checkboxååæ¶åè°ï¼åæ°ä¸ºå½åæéæ¸å */
  // tslint:disable-next-line:member-ordering
  @Output()
  readonly checkboxChange: EventEmitter<SimpleTableData[]> = new EventEmitter<
    SimpleTableData[]
  >();
  /** radioååæ¶åè°ï¼åæ°ä¸ºå½åæé */
  // tslint:disable-next-line:member-ordering
  @Output()
  readonly radioChange: EventEmitter<SimpleTableData> = new EventEmitter<
    SimpleTableData
  >();
  /** æåºåè° */
  // tslint:disable-next-line:member-ordering
  @Output()
  readonly sortChange: EventEmitter<any> = new EventEmitter<any>();
  /** Filteråè° */
  // tslint:disable-next-line:member-ordering
  @Output()
  readonly filterChange: EventEmitter<SimpleTableColumn> = new EventEmitter<
    SimpleTableColumn
  >();
  /** åç«¯åé¡µæ¯å¦éç¨`1`åºç´¢å¼ï¼åªå¨`data`ç±»åä¸º`string`æ¶ææ */
  @Input()
  get zeroIndexedOnPage() {
    return this._zeroIndexedOnPage;
  }
  set zeroIndexedOnPage(value: any) {
    this._zeroIndexedOnPage = toBoolean(value);
  }
  // tslint:disable-next-line:member-ordering
  private _zeroIndexedOnPage = false;

  // endregion

  constructor(
    private defConfig: AdSimpleTableConfig,
    private http: HttpClient,
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private exportSrv: SimpleTableExport,
    // @Optional() private acl: ACLService,

    private modal: ModalHelper,
    private currenty: CNCurrencyPipe,
    private date: DatePipe,
    private yn: YNPipe,
    private number: DecimalPipe,
    @Inject(DOCUMENT) private doc: any
  ) {
    Object.assign(this, deepCopy(defConfig));
  }

  // region: data

  /**
   * æ ¹æ®é¡µç éæ°å è½½æ°æ®
   *
   * @param pi æå®å½åé¡µç ï¼é»è®¤ï¼`1`
   * @param extraParams éæ°æå® `extraParams` å¼
   */
  load(pi = 1, extraParams?: any) {
    if (pi !== -1) {
      this.pi = pi;
    }
    if (typeof extraParams !== "undefined") {
      this.extraParams = extraParams;
    }
    this._change("pi");
  }

  /**
   * éæ°å·æ°å½åé¡µ
   * @param extraParams éæ°æå® `extraParams` å¼
   */
  reload(extraParams?: any) {
    this.load(-1, extraParams);
  }

  /**
   * éç½®ä¸éæ°è®¾ç½® `pi` ä¸º `1`
   *
   * @param extraParams éæ°æå® `extraParams` å¼
   */
  reset(extraParams?: any) {
    this.load(1, extraParams);
  }

  private getAjaxData(url?: string): Observable<any> {
    const params: any = Object.assign(
      {
        [this.reqReName.pi]: this._zeroIndexedOnPage ? this.pi - 1 : this.pi,
        [this.reqReName.ps]: this.ps
      },
      this.extraParams,
      this.getReqSortMap(),
      this.getReqFilterMap()
    );
    return this.http
      .request(this.reqMethod || "GET", url || this._url, {
        params,
        body: this.reqBody,
        headers: this.reqHeaders
      })
      .pipe(
        map((res: any) => {
          // list
          let ret = deepGet(res, this.resReName.list as string[], []);
          if (ret == null || !Array.isArray(ret)) {
            ret = [];
          }
          // total
          const retTotal =
            this.resReName.total &&
            deepGet(res, this.resReName.total as string[], null);
          this.total = retTotal == null ? this.total || 0 : +retTotal;
          return <any[]>ret;
        })
      );
  }

  private _genAjax(forceRefresh: boolean = false) {
    if (!this._isAjax) {
      return;
    }
    this.loading = true;
    if (forceRefresh === true) {
      this.pi = 1;
    }
    this.getAjaxData().subscribe(
      (res: any) => this.checkPaged().subscribeData(res),
      err => {
        this.loading = false;
        this.reqError.emit(err);
      }
    );
  }

  _genData(forceRefresh: boolean = false) {
    if (this._isAjax) {
      return;
    }
    let data = (<any[]>this.data).slice(0);
    // sort
    const sorterFn = this.getSorterFn();
    if (sorterFn) {
      data = data.sort(sorterFn);
    }

    // filter
    this._columns.filter(w => w.filters && w.filters.length).forEach(c => {
      const values = c.filters.filter(w => w.checked);
      if (values.length === 0) {
        return;
      }
      const onFilter = c.filter;
      data = data.filter(record => values.some(v => onFilter(v, record)));
    });

    if (forceRefresh) {
      if (this.isPageIndexReset) {
        this.pi = 1;
      } else {
        const maxPageIndex = Math.ceil(data.length / this.ps);
        this.pi = !this.pi
          ? 1
          : this.pi > maxPageIndex
            ? maxPageIndex
            : this.pi;
      }
    }
    this.total = this.frontPagination
      ? data.length
      : this.total <= 0
        ? data.length
        : this.total;
    this.checkPaged().subscribeData(
      this._isPagination && this.frontPagination
        ? data.slice((this.pi - 1) * this.ps, this.pi * this.ps)
        : data
    );
  }

  private _toTop() {
    if (!this.toTopInChange) {
      return;
    }
    if (this.scroll) {
      (this.el.nativeElement as HTMLElement)
        .querySelector(".ant-table-body")
        .scrollTo(0, 0);
      return;
    }
    this.el.nativeElement.scrollIntoView();
    // fix header height
    this.doc.documentElement.scrollTop -= this.toTopOffset;
  }

  private checkPaged(): this {
    this._isPagination =
      typeof this.showPagination === "undefined"
        ? this.ps > 0 && this.total > this.ps
        : this.showPagination;

    return this;
  }

  private processData() {
    if (!this.data) {
      this._isAjax = false;
      this.data = [];
      return;
    }

    this._isAjax = false;
    if (typeof this.data === "string") {
      this._url = this.data as string;
      this._isAjax = true;
      this._genAjax(true);
    } else if (Array.isArray(this.data)) {
      this._genData(this.frontPagination);
    } else {
      if (this.data$) {
        this.data$.unsubscribe();
      }
      this.data$ = this.data
        .pipe(tap(() => (this.loading = true)))
        .subscribe(res => {
          this.data = res;
          this._genData(this.frontPagination);
        });
    }
  }

  private subscribeData(res: any[]) {
    if (this.preDataChange) {
      res = this.preDataChange(res);
    }
    this.loading = false;
    for (const i of res) {
      i._values = this._columns.map(c => this._get(i, c));
    }
    this._data = res;
    this._refCheck();
  }

  _change(type: "pi" | "ps") {
    if (!this._inited) {
      return;
    }
    this._genAjax();
    if (this.frontPagination) {
      this._genData();
    }
    this._toTop();
    this.change.emit({
      type: type,
      pi: this.pi,
      ps: this.ps,
      total: this.total
    });
  }

  _get(item: any, col: SimpleTableColumn) {
    if (col.format) {
      return col.format(item, col);
    }

    const value = deepGet(item, col.index as string[], col.default);

    let ret = value;
    switch (col.type) {
      case "img":
        ret = value ? `<img src="${value}" class="img">` : "";
        break;
      case "number":
        ret = this.number.transform(value, col.numberDigits);
        break;
      case "currency":
        ret = this.currenty.transform(value);
        break;
      case "date":
        ret = this.date.transform(value, col.dateFormat);
        break;
      case "yn":
        ret = this.yn.transform(value === col.ynTruth, col.ynYes, col.ynNo);
        break;
    }
    return ret;
  }

  _click(e: Event, item: any, col: SimpleTableColumn) {
    e.preventDefault();
    e.stopPropagation();
    const res = col.click(item, this);
    if (typeof res === "string") {
      this.router.navigateByUrl(res);
    }
    return false;
  }

  // endregion

  // region: sort

  private getReqSortMap(): { [key: string]: string } {
    let ret: { [key: string]: string } = {};
    if (!this._sortOrder) {
      return ret;
    }

    const ms = this.multiSort;
    if (ms) {
      Object.keys(this._sortMap)
        .filter(key => this._sortMap[key].enabled && this._sortMap[key].v)
        .forEach(key => {
          const item = this._sortMap[key];
          ret[item.key] =
            (item.column.sortReName || this.sortReName || {})[item.v] || item.v;
        });
      // åå¹¶å¤ç
      if (typeof ms === "object") {
        ret = {
          [ms.key]: Object.keys(ret)
            .map(key => key + ms.name_separator + ret[key])
            .join(ms.separator)
        };
      }
    } else {
      const mapData = this._sortMap[this._sortIndex];
      ret[mapData.key] =
        (this._sortColumn.sortReName || this.sortReName || {})[mapData.v] ||
        mapData.v;
    }
    return ret;
  }

  private getSorterFn() {
    if (!this._sortOrder || !this._sortColumn) {
      return;
    }

    return (a: any, b: any) => {
      const result = (this._sortColumn.sorter as CompareFn)(a, b);
      if (result !== 0) {
        return this._sortOrder === "descend" ? -result : result;
      }
      return 0;
    };
  }

  sort(index: number, value: any) {
    this._sortColumn = this._columns[index];
    this._sortOrder = value;
    this._sortIndex = index;
    if (this.multiSort) {
      this._sortMap[index].v = value;
    } else {
      Object.keys(this._sortMap).forEach(
        key => (this._sortMap[key].v = +key === index ? value : null)
      );
    }
    this._genAjax(true);
    this._genData(true);
    this.sortChange.emit({
      value,
      map: this.getReqSortMap(),
      column: this._sortColumn
    });
  }

  // endregion

  // region: filter

  private getReqFilterMap(): { [key: string]: string } {
    let ret = {};
    this._columns.filter(w => w.filtered === true).forEach(col => {
      const values = col.filters.filter(f => f.checked === true);
      let obj: Object = {};
      if (col.filterReName) {
        obj = col.filterReName(col.filters, col);
      } else {
        obj[col.filterKey || col.indexKey] = values.map(i => i.value).join(",");
      }
      ret = Object.assign(ret, obj);
    });
    return ret;
  }

  private handleFilter(col: SimpleTableColumn) {
    col.filtered = col.filters.findIndex(w => w.checked) !== -1;
    this._genAjax(true);
    this._genData(true);
    this.filterChange.emit(col);
  }

  filterConfirm(col: SimpleTableColumn) {
    this.handleFilter(col);
  }

  filterClear(col: SimpleTableColumn) {
    col.filters.forEach(i => (i.checked = false));
    this.handleFilter(col);
  }

  filterRadio(
    col: SimpleTableColumn,
    item: SimpleTableFilter,
    checked: boolean
  ) {
    col.filters.forEach(i => (i.checked = false));
    item.checked = checked;
  }

  // endregion

  // region: checkbox

  /** æ¸é¤ææ `checkbox` */
  clearCheck(): this {
    return this._checkAll(false);
  }

  _checkAll(checked?: boolean): this {
    checked = typeof checked === "undefined" ? this._allChecked : checked;
    this._data.filter(w => !w.disabled).forEach(i => (i.checked = checked));
    return this._refCheck()._checkNotify();
  }

  _checkSelection(i: SimpleTableData, value: boolean) {
    i.checked = value;
    return this._refCheck()._checkNotify();
  }

  _refCheck(): this {
    const validData = this._data.filter(w => !w.disabled);
    const checkedList = validData.filter(w => w.checked === true);
    this._allChecked =
      checkedList.length > 0 && checkedList.length === validData.length;
    const allUnChecked = validData.every(value => !value.checked);
    this._indeterminate = !this._allChecked && !allUnChecked;
    return this;
  }

  _rowSelection(row: SimpleTableSelection): this {
    row.select(this._data);
    return this._refCheck()._checkNotify();
  }

  _checkNotify(): this {
    this.checkboxChange.emit(
      this._data.filter(w => !w.disabled && w.checked === true)
    );
    return this;
  }

  // endregion

  // region: radio

  /** æ¸é¤ææ `radio` */
  clearRadio(): this {
    this._data.filter(w => w.checked).forEach(item => (item.checked = false));
    this.radioChange.emit(null);
    return this;
  }

  _refRadio(checked: boolean, item: SimpleTableData): this {
    // if (item.disabled === true) return;
    this._data.filter(w => !w.disabled).forEach(i => (i.checked = false));
    item.checked = checked;
    this.radioChange.emit(item);
    return this;
  }

  // endregion

  // region: buttons

  btnCoerce(list: SimpleTableButton[]): SimpleTableButton[] {
    if (!list) {
      return [];
    }
    const ret: SimpleTableButton[] = [];
    for (const item of list) {
      // if (this.acl && item.acl && !this.acl.can(item.acl)) { continue; }

      if (item.type === "del" && typeof item.pop === "undefined") {
        item.pop = true;
      }

      if (item.pop === true) {
        item._type = 2;
        if (typeof item.popTitle === "undefined") {
          item.popTitle = `ç¡®è®¤å é¤åï¼`;
        }
      }
      if (item.children && item.children.length > 0) {
        item._type = 3;
        item.children = this.btnCoerce(item.children);
      }
      if (!item._type) {
        item._type = 1;
      }

      // i18n
      // if (item.i18n && this.i18nSrv) { item.text = this.i18nSrv.fanyi(item.i18n); }

      ret.push(item);
    }
    this.btnCoerceIf(ret);
    return ret;
  }

  btnCoerceIf(list: SimpleTableButton[]) {
    for (const item of list) {
      if (!item.iif) {
        item.iif = () => true;
      }
      if (!item.children) {
        item.children = [];
      } else {
        this.btnCoerceIf(item.children);
      }
    }
  }

  btnClick(record: any, btn: SimpleTableButton) {
    if (btn.type === "modal" || btn.type === "static") {
      const obj = {};
      obj[btn.paramName || this.defConfig.modalParamsName || "record"] = record;
      const options: ModalHelperOptions = Object.assign({}, btn.modal);
      // TODO: deprecated
      if (btn.size) {
        options.size = btn.size;
      }
      if (btn.modalOptions) {
        options.modalOptions = btn.modalOptions;
      }

      (this.modal[btn.type === "modal" ? "create" : "createStatic"] as any)(
        btn.component,
        Object.assign(obj, btn.params && btn.params(record)),
        options
      )
        .pipe(filter(w => typeof w !== "undefined"))
        .subscribe(res => this.btnCallback(record, btn, res));
      return;
    } else if (btn.type === "link") {
      const clickRes = this.btnCallback(record, btn);
      if (typeof clickRes === "string") {
        this.router.navigateByUrl(clickRes);
      }
      return;
    }
    this.btnCallback(record, btn);
  }

  private btnCallback(record: any, btn: SimpleTableButton, modal?: any) {
    if (!btn.click) {
      return;
    }
    if (typeof btn.click === "string") {
      switch (btn.click) {
        case "load":
          this.load();
          break;
        case "reload":
          this.reload();
          break;
      }
    } else {
      return btn.click(record, modal, this);
    }
  }

  btnText(record: any, btn: SimpleTableButton) {
    if (btn.format) {
      return btn.format(record, btn);
    }
    return btn.text;
  }

  // endregion

  // region: fixed

  fixedCoerce(list: SimpleTableColumn[]) {
    list.forEach((item, idx) => {
      if (item.fixed && item.width) {
        if (item.fixed === "left") {
          item._left = idx === 0 ? "0px" : list[idx - 1].width;
        } else {
          item._right = idx === list.length - 1 ? "0px" : list[idx + 1].width;
        }
      }
    });
  }

  // endregion

  // region: export

  /**
   * å¯¼åºExcelï¼ç¡®ä¿å·²ç»æ³¨å `AdXlsxModule`
   * @param urlOrData éæ°æå®æ°æ®ï¼ä¾å¦å¸æå¯¼åºæææ°æ®éå¸¸æç¨
   * @param opt é¢å¤åæ°
   */
  export(urlOrData?: string | any[], opt?: STExportOptions) {
    (urlOrData
      ? typeof urlOrData === "string"
        ? this.getAjaxData(urlOrData)
        : of(urlOrData)
      : this._isAjax
        ? this.getAjaxData()
        : of(this.data)
    ).subscribe((res: any[]) =>
      this.exportSrv.export(
        Object.assign({}, opt, <STExportOptions>{
          _d: res,
          _c: this._columns
        })
      )
    );
  }

  // endregion

  ngOnInit(): void {
    this._inited = true;
    this.updateColumns();
    this.processData();
  }

  private setClass() {
    this._classMap.forEach(cls =>
      this.renderer.removeClass(this.el.nativeElement, cls)
    );

    this._classMap = [];
    if (this.pagePlacement) {
      this._classMap.push("ad-st__p" + this.pagePlacement);
    }

    this._classMap.forEach(cls =>
      this.renderer.addClass(this.el.nativeElement, cls)
    );
  }

  private updateColumns() {
    this._columns = [];
    if (!this.columns || this.columns.length === 0) {
      throw new Error(`the columns property muse be define!`);
    }
    let checkboxCount = 0;
    let radioCount = 0;
    const sortMap: Object = {};
    let idx = 0;
    const newColumns: SimpleTableColumn[] = [];
    const copyColumens = deepCopy(this.columns) as SimpleTableColumn[];
    for (const item of copyColumens) {
      // if (this.acl && item.acl && !this.acl.can(item.acl)) { continue; }
      if (item.index) {
        if (!Array.isArray(item.index)) {
          item.index = item.index.split(".");
        }

        item.indexKey = item.index.join(".");
      }
      // rowSelection
      if (!item.selections) {
        item.selections = [];
      }
      if (item.type === "checkbox") {
        ++checkboxCount;
        if (!item.width) {
          item.width = `${item.selections.length > 0 ? 60 : 50}px`;
        }
      }
      if (item.type === "radio") {
        ++radioCount;
        item.selections = [];
        if (!item.width) {
          item.width = "50px";
        }
      }
      if (item.type === "yn" && typeof item.ynTruth === "undefined") {
        item.ynTruth = true;
      }
      if (
        (item.type === "link" && typeof item.click !== "function") ||
        (item.type === "badge" && typeof item.badge === "undefined") ||
        (item.type === "tag" && typeof item.tag === "undefined")
      ) {
        (item as any).type = "";
      }
      if (!item.className) {
        item.className = {
          // 'checkbox': 'text-center',
          // 'radio': 'text-center',
          number: "text-right",
          currency: "text-right",
          date: "text-center"
        }[item.type];
      }

      // sorter
      if (item.sorter && typeof item.sorter === "function") {
        sortMap[idx] = {
          enabled: true,
          v: item.sort,
          key: item.sortKey || item.indexKey,
          column: item
        };
        if (item.sort && !this._sortColumn) {
          this._sortColumn = item;
          this._sortOrder = item.sort;
          this._sortIndex = idx;
        }
      } else {
        sortMap[idx] = {
          enabled: false
        };
      }
      // filter
      if (!item.filter || !item.filters) {
        item.filters = [];
      }
      if (typeof item.filterMultiple === "undefined") {
        item.filterMultiple = true;
      }
      if (!item.filterConfirmText) {
        item.filterConfirmText = `ç¡®è®¤`;
      }
      if (!item.filterClearText) {
        item.filterClearText = `éç½®`;
      }
      if (!item.filterIcon) {
        item.filterIcon = `anticon anticon-filter`;
      }
      item.filtered = item.filters.findIndex(w => w.checked) !== -1;

      //   if (this.acl) {
      //     item.selections = item.selections.filter(w => this.acl.can(w.acl));
      //     item.filters = item.filters.filter(w => this.acl.can(w.acl));
      //   }

      // buttons
      item.buttons = this.btnCoerce(item.buttons);
      // i18n
      // if (item.i18n && this.i18nSrv) { item.title = this.i18nSrv.fanyi(item.i18n); }
      ++idx;
      newColumns.push(item);
    }
    if (checkboxCount > 1) {
      throw new Error(`just only one column checkbox`);
    }
    if (radioCount > 1) {
      throw new Error(`just only one column radio`);
    }
    this.fixedCoerce(newColumns);
    this._columns = newColumns;
    this._sortMap = sortMap;
  }

  ngOnChanges(
    changes: { [P in keyof this]?: SimpleChange } & SimpleChanges
  ): void {
    if (changes.columns && this._inited) {
      this.updateColumns();
    }
    if (changes.data && this._inited) {
      this.processData();
    }

    this.setClass();
  }

  ngOnDestroy(): void {
    if (this.data$) {
      this.data$.unsubscribe();
      this.data$ = null;
    }
  }
}
